export default __webpack_public_path__ + "static/media/la_capelle20.071a59b4.jpg";